/**
 * Draw a square crop from `image` with cover-fit zoom and pan offsets.
 * @returns {Promise<Blob>} PNG blob
 */
export function cropImageToSquareBlob({
  image,
  size = 160,
  scale = 1,
  offsetX = 0,
  offsetY = 0,
  mimeType = 'image/png',
  quality = 0.92,
}) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      reject(new Error('Canvas not supported'));
      return;
    }

    const iw = image.naturalWidth || image.width;
    const ih = image.naturalHeight || image.height;
    if (!iw || !ih) {
      reject(new Error('Invalid image dimensions'));
      return;
    }

    const cover = Math.max(size / iw, size / ih) * Math.max(1, scale);
    const drawW = iw * cover;
    const drawH = ih * cover;
    const dx = (size - drawW) / 2 + offsetX;
    const dy = (size - drawH) / 2 + offsetY;

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);
    ctx.drawImage(image, dx, dy, drawW, drawH);

    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error('Failed to encode image'));
        else resolve(blob);
      },
      mimeType,
      quality
    );
  });
}

export function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not load image'));
    };
    img.src = url;
  });
}
